import { isEmpty } from 'lodash';
import DynamicAssessment from './DynamicAssessment';
import DynamicQuestionDetails from './DynamicQuestionDetails';
import { useRef, useState } from 'react';
import {
  useGetCandidateAssessment,
  useGetCandidateAssessmentAnswer,
} from '../../Hooks/AssesmentHooks';
import Tabs from '../../Components/Tabs/Tabs';
import { useParams } from 'react-router-dom';

const Annotations = (props) => {
  const childRef = useRef();
    const { id } = useParams();
  // const interviewId = 5623
  const [playerControls, setPlayerControls] = useState(null);

  const {
    data: candidatessementData,
    status: candidatessementDataStatus,
    refetch: refetchandidateAssessmentData,
    isLoading: loadingAssessmentData,
    isFetching: fetchingAssessmentData,
  } = useGetCandidateAssessment({
    params: {
      interview_id: id,
    },
    enabled: !!id,
  });

  const {
    data: candidatessementAnswer,
    status: candidatessementAnswerStatus,
    refetch: refetchandidateAssessmentAnswer,
    isLoading: loadingAnswerDetails,
    isFetching: fetchingAnswerDetails,
  } = useGetCandidateAssessmentAnswer({
    params: {
      interview_id: id,
    },
    enabled: !!id,
  });

  const handleTabChange = (activeKey) => {
    console.log(activeKey, 'activeKeyactiveKey', candidatessementAnswer);
    if (
      activeKey === 'details' &&
      candidatessementAnswer &&
      !candidatessementAnswer?.answer_video
    ) {
      refetchandidateAssessmentAnswer()
    }else {
      if (playerControls) {
        console.log(playerControls,"playerControls");
        playerControls.pause();
      }
    }

  };

  const tabsArray = [
    {
      key: 'assessment',
      tabName: 'Candidate Assessment',
      children: (
        <DynamicAssessment
          candidatessementData={candidatessementData}
          isLoading={loadingAssessmentData || fetchingAssessmentData}
        />
      ),
    },
    {
      key: 'details',
      tabName: 'Detailed Question and Answers',
      children: (
        <DynamicQuestionDetails
          candidatessementAnswer={candidatessementAnswer}
          ref={childRef}
          isLoading={loadingAnswerDetails || fetchingAnswerDetails}
          setPlayerControls={setPlayerControls}
        />
      ),
    },
  ].filter((item) => !isEmpty(item));

  const tabsItems = tabsArray.map((item) => {
    return {
      key: item.key,
      label: item.tabName,
      children: item.children,
    };
  });
  return (
    <div>
      <Tabs
        items={tabsItems}
        className="questionsTab"
        onChange={handleTabChange}
      />
    </div>
  );
};

export default Annotations;
